import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
  behavior?: ScrollBehavior; // 'auto' | 'smooth'
  enabled?: boolean;
};

// Rola a janela para o topo sempre que o pathname (ou query) mudar.
// Mantém o comportamento suave por padrão e não interfere com rolagem interna por âncora.
const ScrollToTop: React.FC<Props> = ({ behavior = 'smooth', enabled = true }) => {
  const { pathname, search } = useLocation();

  // Desabilita a restauração automática do browser para evitar posições antigas ao navegar.
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      try {
        // Força o browser a não restaurar a posição antiga ao navegar
        (window.history as History & { scrollRestoration?: 'auto' | 'manual' }).scrollRestoration = 'manual';
      } catch (_) {
        // Ignora se o ambiente não suportar
      }
    }
  }, []);

  useEffect(() => {
    if (!enabled) return;
    window.scrollTo({ top: 0, left: 0, behavior });
  }, [pathname, search, behavior, enabled]);

  return null;
};

export default ScrollToTop;